// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"11":"ui/design/css/_wisdom_vendor_listing","56":"ui/design/css/_wisdom_homepage","265":"ui/design/css/_wisdom_category_listing","338":"ui/design/css/main","717":"ui/design/css/_wisdom_product_page"}[chunkId] + ".css";
};